const BuildingsLayer = {
  id: '3d-buildings',
  source: 'composite',
  'source-layer': 'building',
  filter: ['==', 'extrude', 'true'],
  type: 'fill-extrusion',
  minzoom: 12,
  paint: {
    'fill-extrusion-color': '#ccc',
    'fill-extrusion-height': ['interpolate', ['linear'], ['zoom'], 15, 0, 15.05, ['get', 'height']],
    'fill-extrusion-base': ['interpolate', ['linear'], ['zoom'], 15, 0, 15.05, ['get', 'min_height']],
    'fill-extrusion-opacity': 0.6,
  },
};

const PointsSource = {
  type: 'geojson',
  data: {
    type: 'FeatureCollection',
    features: [],
  },
};

const PointsLayer = {
  id: 'points',
  type: 'circle',
  source: 'points',
  paint: {
    'circle-radius': 4,
    'circle-color': '#2cc300',
  },
};

const LinesSource = {
  type: 'geojson',
  data: {
    type: 'Feature',
    properties: {},
    geometry: {
      type: 'LineString',
      coordinates: [],
    },
  },
};

const LinesLayer = {
  id: 'lines',
  type: 'line',
  source: 'lines',
  layout: {
    'line-join': 'round',
    'line-cap': 'round',
  },
  paint: {
    'line-color': '#38ed04',
    'line-width': 4,
  },
};

export { BuildingsLayer, PointsSource, PointsLayer, LinesSource, LinesLayer };
